import _ from "lodash";
import {ModuleConfigFile, ModuleConfigs} from "./types";

export const getModuleConfigs = (moduleConfigFiles: ModuleConfigFile[], getState: any, dispatch: any, t: any) => {
  const modulesConfig: ModuleConfigs = {
    modules: [],
    configs: {},
    placeholders: {},
    hubRoutes: [],
    nodeRoutes: [],
    hubPermissions: [],
    nodePermissions: [],
    tableActionFactories: {}
  };

  moduleConfigFiles.forEach(module => {
    const {
      id: moduleId,
      config,
      getPlaceholders = null,
      getHubRoutes = null,
      getNodeRoutes = null,
      getHubPermissions = null,
      getNodePermissions = null,
      getTableActions = null
    } = module;

    modulesConfig.modules.push(moduleId);

    modulesConfig.configs[moduleId] = config || null;

    if (getPlaceholders) {
      getPlaceholders(t).forEach(({placeholder, component, fallback, ...props}) => {
        if (!modulesConfig.placeholders[placeholder]) {
          modulesConfig.placeholders[placeholder] = [];
        }
        modulesConfig.placeholders[placeholder].push({
          id: moduleId,
          component: component,
          fallback: fallback,
          ...props
        });
      });
    }

    if (getHubRoutes) {
      getHubRoutes(t).forEach(({route, component, fallback, ...props}) => {
        modulesConfig.hubRoutes.push({
          id: moduleId,
          route: route,
          component: component,
          fallback: fallback,
          ...props
        });
      });
    }

    if (getNodeRoutes) {
      getNodeRoutes(t).forEach(({route, component, fallback, ...props}) => {
        modulesConfig.nodeRoutes.push({
          id: moduleId,
          route: route,
          component: component,
          fallback: fallback,
          ...props
        });
      });
    }

    if (getHubPermissions) {
      getHubPermissions(t).forEach(permission => {
        modulesConfig.hubPermissions.push(permission);
      });
    }

    if (getNodePermissions) {
      getNodePermissions(t).forEach(permission => {
        modulesConfig.nodePermissions.push(permission);
      });
    }

    if (getTableActions) {
      getTableActions(getState, dispatch, t).forEach(({placeholder, getAction}) => {
        if (!modulesConfig.tableActionFactories[placeholder]) {
          modulesConfig.tableActionFactories[placeholder] = [];
        }
        modulesConfig.tableActionFactories[placeholder].push(getAction);
      });
    }
  });

  modulesConfig.hubPermissions = _.uniqBy(modulesConfig.hubPermissions, "id");
  modulesConfig.nodePermissions = _.uniqBy(modulesConfig.nodePermissions, "id");

  return modulesConfig;
};
